import { Avatar, AvatarProps } from '@mui/material';
import { currencyImages } from './CurrencyImage';

interface AvatarCurrencyProps extends AvatarProps {
  currency: string | null | undefined;
}

export function AvatarCurrency({ currency, ...props }: AvatarCurrencyProps) {
  const src = currency ? currencyImages[currency] : undefined;
  return (
    <Avatar
      src={src}
      alt={currency ?? ' '}
      {...props}
      sx={[
        src
          ? {
              background: 'none',
            }
          : {
              background: null,
            },
      ]}
    >
      {currency ? (currency.length > 3 ? currency[0] : currency) : ' '}
    </Avatar>
  );
}
